import { createFileRoute } from "@tanstack/react-router";

import type { NavigationSectionGroup } from "@/components/Navigation/NavigationCard";
import { CForm } from "@/features/c-form/CForm";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { BudgetCostSection } from "./-components/BudgetCostSection";
import { ContractInformationSection } from "./-components/ContractInformationSection";
import { PlanInformationSection } from "./-components/PlanInformationSection";

export const Route = createFileRoute(
  "/_staff/software/$id/_$id/contracts-cost/",
)({
  component: SoftwareContractsCost,
});

function SoftwareContractsCost() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.software.profile.contractsCost.navigation",
  });

  const navigationSectionGroups: NavigationSectionGroup[] = [
    {
      titleLabel: t("contractInformation"),
      to: "",
      hash: "contract-information",
    },
    {
      titleLabel: t("planInformation"),
      to: "",
      hash: "plan-information",
    },
    {
      titleLabel: t("budgetCost"),
      to: "",
      hash: "budget-cost",
    },
  ];

  return (
    <CForm
      editUnit="section"
      itemLayout="label"
      navigationSectionGroups={navigationSectionGroups}
      onReset={() => {}}
    >
      <ContractInformationSection />
      <PlanInformationSection />
      <BudgetCostSection />
    </CForm>
  );
}
